module.exports = __webpack_public_path__ + "static/media/amarillo.633313c6.svg";